<div class="manage-categories-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-icon" aria-hidden="true">
      <mat-icon>category</mat-icon>
    </div>
    <div class="header-content">
      <h2 class="dialog-title">Categories</h2>
    </div>
    <button class="close-btn" (click)="close()" type="button" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content -->
  <div class="dialog-content">
    <div class="categories-info-section">
      <div class="categories-info-row">
        <div class="categories-description">
          Categorising your emails and calendar can help you organise and track messages and events related
          to a project, task or person. You can create new categories and assign them names and colours.
        </div>
        <button mat-stroked-button color="primary" class="create-btn" (click)="openAddEditCategoryDialog()">
          <i class="fas fa-plus" ></i> Create new
        </button>
      </div>
      <hr class="categories-divider">
      <div class="category-section">
        <div class="category-header-row">
          <span class="category-header">Category name</span>
        </div>
        @for (category of calendarCategories; track category) {
          <div class="category-row">
            <span class="cat-icon" [style.color]="category?.color || '#ff6600'">
              <i class="fas fa-tag"></i>
            </span>
            <span class="cat-label">{{category?.title}}</span>
            <span class="cat-actions">
              <i class="far fa-edit" (click)="openAddEditCategoryDialog(category)"></i>
              <i class="far fa-trash-alt" (click)="onDeleteConfirmation(category.id)"></i>
            </span>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Dialog Footer -->
  <div class="dialog-footer">
    <button class="btn-cancel" (click)="close()">
      <mat-icon>close</mat-icon>
      Cancel
    </button>
  </div>
</div>